import { render } from "./FileType.vue?vue&type=template&id=2f4641a3"
import script from "./FileType.vue?vue&type=script&lang=js"
export * from "./FileType.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/interfaces/interfaces/apps/flowform/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__